'use strict'

const hosts = {
  user: 'https://mohaji.hanatour.com',
  userMobile: 'https://dev-user-mobile.hanatour.com',
  seller: 'https://dev-seller.hanatour.com',
  hanatour: 'https://devtour.hanatour.com',
  hanatourAccount: 'https://dev-accounts.hanatour.com',
  hanatourApi: 'https://devapi.hanatour.com',
  hanatourGw: 'https://dev-gw.hanatour.com',
  hanatourImg: 'https://devimage.hanatour.com',
  fndStatic: 'https://dev-static.hanatour.com',
  hatsApi: 'https://dev-hats.hanatour.com',
  hanatourPay: 'https://dev-pay.hanatour.com',
}

// 외부 API
const externalApi = {
  googleMap: {
    key: 'AIzaSyAKlC9AdN5hLaRGU83cbsaBQw8Y6EeDBC0',
  },
  googleAnalytic: {
    key: '',
  },
}

module.exports = {
  hosts,
  externalApi,
  deployEnv: 'local',
  axiosTimeout: 30000,
  gtxSellerIds: ['MHJ-S230803001', 'MHJ-S230803001'], // 글로벌틱스 seller id (환경 내에서도 계정이 여러개일 수 있다)
  jtrSellerIds: ['MHJ-S220623001', 'MHJ-S220811001'], // JTR seller id
  grlSellerIds: ['MHJ-U23090400000001', 'MHJ-S230904001'],
}
